import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'

export function GridBackground() {
  const theme = useTheme()
  const primaryBlue = theme.palette.primary.main // #3B82F6

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        pointerEvents: 'none',
        background: `
          repeating-linear-gradient(
            0deg,
            transparent,
            transparent 99px,
            ${primaryBlue}40 99px,
            ${primaryBlue}40 100px
          ),
          repeating-linear-gradient(
            90deg,
            transparent,
            transparent 99px,
            ${primaryBlue}40 99px,
            ${primaryBlue}40 100px
          )
        `,
      }}
    />
  )
}
